/* ==========================================================================
   KINOVA — SUZUVCHI TUGMALAR va QO'LLAB-QUVVATLASH CHATI
   ==========================================================================
   HAR BIR ommaviy sahifada (bosh sahifa, kinolar, qidiruv, pleer, profil,
   ...) o'ng pastda ikkita tugma turadi:

     1. QO'LLAB-QUVVATLASH — bosilganda YOZISHUV oynasi ochiladi.
     2. TEPAGA — sahifa pastga siljitilganda paydo bo'ladi.

   ── 23-BOSQICH: FORMA O'RNIGA CHAT ────────────────────────────────────
   Foydalanuvchi talabi (04.10.2026): "qo'llab-quvvatlashning dizaynini
   o'zgartir, messenger'day bo'lsin … Telegramdagi suhbatday, ikki kishi
   o'rtasida … murojaatchining ismini avtomatik nickname orqali olsin".

   ILGARI: har safar ism + email + "murojaat matni" to'ldiriladigan forma,
   javoblar esa alohida ro'yxatda. Suhbat yo'q edi va ism qo'lda yozilardi.

   ENDI (tizimga kirganlar uchun): bitta uzluksiz yozishuv — pufakchalar,
   pastda matn maydoni, Enter bilan yuborish. Ism hisobdan O'ZI olinadi.
   Xabar Telegram botiga ketadi; administrator o'sha xabarga REPLY qilsa
   javob shu yerda paydo bo'ladi (App\Services\Support\TelegramSupport).

   MEHMON uchun esa ESKI forma AYNAN avvalgidek qoladi (`POST /aloqa`) —
   hisobi yo'q odamning suhbati ham bo'lmaydi, lekin yozish imkoni
   yo'qolmasligi kerak.

   ⚠️ NIMA UCHUN ALOHIDA FAYL: `main.js`/`components.js`/`icons.js` dizayn
      manbasidan bayt-bayt ajratilgan fayllar (`scripts/extract-assets.mjs`
      qo'riqlaydi). Bu modul mustaqil — `app.js` zanjirining oxirida
      import qilinadi va o'zini o'zi `<body>`ga joylaydi.

   ⚠️ Yangi rang/token YO'Q — barcha qiymatlar `tokens.css`dan
      (resources/css/support.css).

   ⚠️ ADMIN panelda ko'rinmaydi: admin bundle `app.js`ni import qilmaydi.
   ========================================================================== */
(function (global) {
  'use strict';

  var SUPPORT_SUBJECT = "Qo'llab-quvvatlash so'rovi";

  /* Oyna ochiq turganda administrator javobi O'ZI paydo bo'lishi uchun
     qisqa so'rov oralig'i. Oyna yopilsa so'rov TO'XTAYDI — bekorga
     trafik sarflanmaydi. */
  var POLL_MS = 12000;

  function ready(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }

  function icon(name, size) {
    var Icon = global.Icon || {};
    var fn = Icon[name] || Icon.tag;

    return typeof fn === 'function' ? fn(size || 20) : '';
  }

  /* ── 17-bosqich: suzuvchi tugmalar uchun MAXSUS belgilar ───────────
     ⚠️ `icons.js` dizayn manbasidan bayt-bayt ajratilgan (o'zgartirib
        bo'lmaydi), shuning uchun bu belgilar shu yerda chiziladi. */

  /** Qo'llab-quvvatlash — garnitura (operator) belgisi. */
  function headsetIcon(size) {
    var s = size || 22;

    return '<svg width="' + s + '" height="' + s + '" viewBox="0 0 24 24" fill="none" ' +
      'stroke="currentColor" stroke-width="1.9" stroke-linecap="round" stroke-linejoin="round" ' +
      'aria-hidden="true" focusable="false">' +
      '<path d="M4 13.5V12a8 8 0 0 1 16 0v1.5"/>' +
      '<rect x="2" y="13" width="4.6" height="7" rx="2.3"/>' +
      '<rect x="17.4" y="13" width="4.6" height="7" rx="2.3"/>' +
      '<path d="M19.7 20v.4a2.6 2.6 0 0 1-2.6 2.6H14"/>' +
      '</svg>';
  }

  /** Yuborish — qog'oz samolyot (icons.js da `send` yo'q). */
  function sendIcon(size) {
    var s = size || 17;

    return '<svg width="' + s + '" height="' + s + '" viewBox="0 0 24 24" fill="none" ' +
      'stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" ' +
      'aria-hidden="true" focusable="false">' +
      '<path d="M21 3 10.5 13.5"/>' +
      '<path d="M21 3l-6.8 18-3.7-7.5L3 9.8 21 3z"/>' +
      '</svg>';
  }

  /** Tepaga — qalin, aniq strelka. */
  function arrowUpIcon(size) {
    var s = size || 22;

    return '<svg width="' + s + '" height="' + s + '" viewBox="0 0 24 24" fill="none" ' +
      'stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round" ' +
      'aria-hidden="true" focusable="false">' +
      '<path d="M12 19.5V5.5"/>' +
      '<path d="M5.2 12.3 12 5.5l6.8 6.8"/>' +
      '</svg>';
  }

  function esc(v) {
    return String(v === null || v === undefined ? '' : v)
      .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;').replace(/'/g, '&#39;');
  }

  /** Matndagi qator tashlashlarni saqlaydi (xabar o'z shaklida ko'rinsin). */
  function escMultiline(v) {
    return esc(v).replace(/\r?\n/g, '<br>');
  }

  function currentUser() {
    var D = global.KDATA || {};

    return D.CURRENT_USER || null;
  }

  /* ⚠️ CSRF token sayt bo'ylab `window.KINOVA_CSRF_TOKEN` orqali
     beriladi (layouts/app.blade.php) — YANGI <meta> tegi ATAYLAB
     qo'shilmaydi: `partials/head.blade.php` dizayn manbasidan
     bayt-bayt ko'zgulanadi va yangi meta teg vizual/DOM tenglik
     tekshiruvini buzardi. */
  function csrfToken() {
    return global.KINOVA_CSRF_TOKEN || '';
  }

  /* ── Markup ──────────────────────────────────────────────────────── */

  function chatPaneHTML() {
    return '' +
      '<div class="support-pane support-pane--chat" id="supportPaneChat">' +
      '<div class="support-chat" id="supportChat" aria-live="polite">' +
      '<div class="support-chat__state" id="supportChatState">Yuklanmoqda…</div>' +
      '</div>' +
      '<form class="support-composer" id="supportComposer">' +
      '<textarea class="support-composer__input" id="supportInput" rows="1" maxlength="2000" ' +
      'placeholder="Xabaringizni yozing…" aria-label="Xabar matni"></textarea>' +
      '<button type="submit" class="support-composer__send" id="supportSend" aria-label="Yuborish">' +
      sendIcon(18) + '</button>' +
      '</form>' +
      '</div>';
  }

  /** Mehmon uchun — ESKI forma (o'zgarmagan xatti-harakat). */
  function guestPaneHTML() {
    return '' +
      '<div class="support-pane" id="supportPaneNew">' +
      '<p class="support-guest-note">Tizimga kirsangiz yozishuv saqlanadi va javobni shu yerda ko\'rasiz. ' +
      '<a href="/login">Kirish</a></p>' +
      '<form id="supportForm" novalidate>' +
      '<div class="field">' +
      '<label for="supportName">Ismingiz</label>' +
      '<input type="text" id="supportName" name="name" maxlength="100" required value="">' +
      '</div>' +
      '<div class="field">' +
      '<label for="supportEmail">Email</label>' +
      '<input type="email" id="supportEmail" name="email" maxlength="190" required value="">' +
      '</div>' +
      '<div class="field">' +
      '<label for="supportMessage">Murojaat matni</label>' +
      '<textarea id="supportMessage" name="message" rows="6" maxlength="5000" required ' +
      'placeholder="Muammoni batafsil yozing: qaysi sahifada, nima qildingiz, nima bo\'ldi."></textarea>' +
      '</div>' +
      '<div class="support-modal__alert" id="supportAlert" hidden></div>' +
      '<button type="submit" class="btn btn--primary btn--lg btn--block support-form__submit" id="supportSubmit">' +
      sendIcon(17) + ' Yuborish</button>' +
      '</form>' +
      '</div>';
  }

  function widgetHTML() {
    var user = currentUser();
    var unread = (user && Number(user.supportUnread)) || 0;
    var subtitle = user
      ? 'Savolingizga administrator javob beradi'
      : 'Murojaatingizni yozing — administrator javob beradi';

    return '' +
      '<div class="support-fab" id="supportFab">' +
      '<div class="support-fab__wrap">' +
      '<button type="button" class="support-fab__btn support-fab__btn--help" id="supportOpen"' +
      ' aria-label="Qo\'llab-quvvatlash">' +
      headsetIcon(23) +
      '</button>' +
      '<span class="support-fab__badge" id="supportBadge"' + (unread ? '' : ' hidden') + '>' + unread + '</span>' +
      '</div>' +
      '<button type="button" class="support-fab__btn support-fab__btn--top" id="supportToTop"' +
      ' aria-label="Tepaga" hidden>' +
      arrowUpIcon(22) +
      '</button>' +
      '</div>' +

      '<div class="modal-overlay" id="supportOverlay" role="dialog" aria-modal="true" aria-labelledby="supportTitle">' +
      '<div class="modal support-modal support-modal--chat">' +

      '<div class="support-modal__head">' +
      '<span class="support-modal__head-icon">' + headsetIcon(24) + '</span>' +
      '<div class="support-modal__head-text">' +
      '<h3 id="supportTitle">KINOVA yordam</h3>' +
      '<p>' + esc(subtitle) + '</p>' +
      '</div>' +
      '<button type="button" class="icon-btn support-modal__close" id="supportClose" aria-label="Yopish">' +
      icon('close', 18) +
      '</button>' +
      '</div>' +

      (user ? chatPaneHTML() : guestPaneHTML()) +

      '</div>' +
      '</div>';
  }

  /* ── O'QILDI BELGISI (bitichka) ────────────────────────────────────
     Foydalanuvchi talabi (05.10.2026): "xabar yuborilganda 1 ta bitichka
     vaqti oldida; agar javob kelsa — u ko'rgan hisoblanib 2 ta bitichka".

     BITTA bitichka = yetib bordi (saqlandi va Telegramga ketdi).
     IKKITA bitichka = administrator javob yozdi, demak o'qidi.

     ⚠️ Belgilar `icons.js` da yo'q (u fayl dizayn manbasidan bayt-bayt
        ajratilgan), shuning uchun shu yerda chiziladi. O'lcham kichik va
        ixcham — vaqtning yonida, pufakchani kengaytirmaydi. */
  function tickHTML(seen) {
    var stroke = 'fill="none" stroke="currentColor" stroke-width="2.2" ' +
      'stroke-linecap="round" stroke-linejoin="round"';

    if (seen) {
      return '<span class="support-bubble__ticks is-seen" title="O\'qildi" aria-label="O\'qildi" role="img">' +
        '<svg width="17" height="11" viewBox="0 0 18.5 12" ' + stroke + ' focusable="false">' +
        '<path d="M8.1 6.9 11.2 10 16.9 2.6"/>' +
        '<path d="M1.3 6.9 4.4 10 10.1 2.6"/>' +
        '</svg></span>';
    }

    return '<span class="support-bubble__ticks" title="Yuborildi" aria-label="Yuborildi" role="img">' +
      '<svg width="11" height="11" viewBox="0 0 12 12" ' + stroke + ' focusable="false">' +
      '<path d="M1.4 6.9 4.5 10 10.2 2.6"/>' +
      '</svg></span>';
  }

  /** Bitta yozishuv pufakchasi. */
  function bubbleHTML(m) {
    var side = m.mine ? 'is-mine' : 'is-them';

    return '<div class="support-bubble ' + side + '">' +
      '<div class="support-bubble__body">' + escMultiline(m.body) + '</div>' +
      '<span class="support-bubble__time">' +
      '<span class="support-bubble__clock">' + esc(m.time || '') + '</span>' +
      (m.mine ? tickHTML(m.seen === true) : '') +
      '</span>' +
      '</div>';
  }

  /** Kun ajratgichi ("04.10.2026"). */
  function dayHTML(label) {
    return '<div class="support-chat__day"><span>' + esc(label) + '</span></div>';
  }

  /* ── Mantiq ──────────────────────────────────────────────────────── */

  function wire() {
    var overlay = document.getElementById('supportOverlay');
    var openBtn = document.getElementById('supportOpen');
    var closeBtn = document.getElementById('supportClose');
    var toTop = document.getElementById('supportToTop');
    var badge = document.getElementById('supportBadge');
    var user = currentUser();

    if (!overlay || !openBtn) return;

    /* ── Tepaga tugmasi (o'zgarmagan xatti-harakat) ───────────────── */
    function syncTopBtn() {
      if (!toTop) return;
      var y = global.pageYOffset || document.documentElement.scrollTop || 0;
      toTop.hidden = y < 400;
    }

    global.addEventListener('scroll', syncTopBtn, { passive: true });
    syncTopBtn();

    if (toTop) {
      toTop.addEventListener('click', function () {
        global.scrollTo({ top: 0, behavior: 'smooth' });
      });
    }

    /* ── Oynani ochish/yopish ─────────────────────────────────────── */
    var lastFocus = null;
    var pollTimer = null;

    function setUnread(n) {
      if (!badge) return;
      badge.textContent = n;
      badge.hidden = n < 1;
    }

    function open() {
      lastFocus = document.activeElement;
      overlay.classList.add('is-open');
      document.body.classList.add('no-scroll');

      if (user) {
        loadThread(true);
        pollTimer = global.setInterval(function () { loadThread(false); }, POLL_MS);
        var input = document.getElementById('supportInput');
        if (input) global.setTimeout(function () { input.focus(); }, 60);
      }
    }

    function close() {
      overlay.classList.remove('is-open');
      document.body.classList.remove('no-scroll');

      if (pollTimer) { global.clearInterval(pollTimer); pollTimer = null; }
      if (lastFocus && lastFocus.focus) lastFocus.focus();
    }

    openBtn.addEventListener('click', open);
    if (closeBtn) closeBtn.addEventListener('click', close);

    overlay.addEventListener('click', function (e) {
      if (e.target === overlay) close();
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && overlay.classList.contains('is-open')) close();
    });

    /* ── Yozishuv ─────────────────────────────────────────────────── */
    var chat = document.getElementById('supportChat');
    var stateEl = document.getElementById('supportChatState');
    var composer = document.getElementById('supportComposer');
    var input = document.getElementById('supportInput');
    var sendBtn = document.getElementById('supportSend');
    var lastId = 0;
    var loading = false;

    function atBottom() {
      if (!chat) return true;

      return chat.scrollHeight - chat.scrollTop - chat.clientHeight < 60;
    }

    function toBottom() {
      if (chat) chat.scrollTop = chat.scrollHeight;
    }

    function render(messages) {
      if (!chat) return;

      if (!messages.length) {
        chat.innerHTML = '<div class="support-chat__state">' +
          'Salom! Savolingizni yozing — administrator javob beradi.</div>';

        return;
      }

      var html = '';
      var day = '';

      messages.forEach(function (m) {
        if (m.date && m.date !== day) { day = m.date; html += dayHTML(day); }
        html += bubbleHTML(m);
      });

      chat.innerHTML = html;
      lastId = messages[messages.length - 1].id || lastId;
    }

    function loadThread(force) {
      if (!chat || loading) return;
      loading = true;

      fetch('/chat', {
        credentials: 'same-origin',
        headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      })
        .then(function (r) { return r.json().catch(function () { return {}; }); })
        .then(function (b) {
          loading = false;
          if (!b || b.ok !== true) {
            if (stateEl && force) stateEl.textContent = 'Yozishuvni ochib bo\'lmadi.';

            return;
          }

          var messages = b.messages || [];
          var newest = messages.length ? (messages[messages.length - 1].id || 0) : 0;

          // Hech narsa o'zgarmagan bo'lsa qayta chizmaymiz — matn
          // tanlangan bo'lsa yo'qolib ketmasin.
          if (!force && newest === lastId) return;

          var stick = force || atBottom();
          render(messages);
          setUnread(0);
          if (stick) toBottom();
        })
        .catch(function () {
          loading = false;
          if (stateEl && force) stateEl.textContent = 'Internet aloqasi yo\'q.';
        });
    }

    /* Matn maydoni yozilgan sari o'sadi (messenger odati). */
    function autoGrow() {
      if (!input) return;
      input.style.height = 'auto';
      input.style.height = Math.min(input.scrollHeight, 132) + 'px';
    }

    if (input) {
      input.addEventListener('input', autoGrow);
      input.addEventListener('keydown', function (e) {
        // Enter — yuborish, Shift+Enter — yangi qator.
        if (e.key === 'Enter' && !e.shiftKey) {
          e.preventDefault();
          if (composer) composer.requestSubmit ? composer.requestSubmit() : composer.dispatchEvent(new Event('submit', { cancelable: true }));
        }
      });
    }

    if (composer) {
      composer.addEventListener('submit', function (e) {
        e.preventDefault();

        var body = (input && input.value || '').trim();
        if (!body || !sendBtn || sendBtn.disabled) return;

        sendBtn.disabled = true;

        fetch('/chat', {
          method: 'POST',
          credentials: 'same-origin',
          headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
            'X-Requested-With': 'XMLHttpRequest',
            'X-CSRF-TOKEN': csrfToken(),
          },
          body: JSON.stringify({ body: body }),
        })
          .then(function (r) {
            return r.json().catch(function () { return {}; })
              .then(function (b) { return { status: r.status, body: b }; });
          })
          .then(function (res) {
            sendBtn.disabled = false;

            if (res.status !== 200 || !res.body || res.body.ok !== true) {
              var why = (res.body && res.body.errors && res.body.errors.body && res.body.errors.body[0])
                || (res.status === 429 ? 'Juda tez yozyapsiz — bir oz kuting.' : 'Yuborilmadi, qaytadan urinib ko\'ring.');
              if (chat) chat.insertAdjacentHTML('beforeend', '<div class="support-chat__error">' + esc(why) + '</div>');
              toBottom();

              return;
            }

            if (input) { input.value = ''; autoGrow(); input.focus(); }
            // Bo'sh holat matni qolib ketmasin.
            var empty = chat && chat.querySelector('.support-chat__state');
            if (empty) empty.remove();

            if (chat && res.body.message) {
              chat.insertAdjacentHTML('beforeend', bubbleHTML(res.body.message));
              lastId = res.body.message.id || lastId;
              toBottom();
            }
          })
          .catch(function () {
            sendBtn.disabled = false;
            if (chat) chat.insertAdjacentHTML('beforeend', '<div class="support-chat__error">Internet aloqasi yo\'q.</div>');
            toBottom();
          });
      });
    }

    /* ── Mehmon formasi (o'zgarmagan) ─────────────────────────────── */
    var form = document.getElementById('supportForm');

    if (form) {
      var alertEl = document.getElementById('supportAlert');
      var submitBtn = document.getElementById('supportSubmit');

      function showAlert(text, kind) {
        if (!alertEl) return;
        alertEl.textContent = text;
        alertEl.className = 'support-modal__alert support-modal__alert--' + kind;
        alertEl.hidden = false;
      }

      form.addEventListener('submit', function (e) {
        e.preventDefault();

        var name = (document.getElementById('supportName') || {}).value || '';
        var email = (document.getElementById('supportEmail') || {}).value || '';
        var message = (document.getElementById('supportMessage') || {}).value || '';

        if (!name.trim() || !message.trim()) {
          showAlert('Ism va murojaat matnini to\'ldiring.', 'error');

          return;
        }

        var submitHTML = submitBtn ? submitBtn.innerHTML : '';
        if (submitBtn) { submitBtn.disabled = true; submitBtn.textContent = 'Yuborilmoqda…'; }

        fetch('/aloqa', {
          method: 'POST',
          credentials: 'same-origin',
          headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
            'X-Requested-With': 'XMLHttpRequest',
            'X-CSRF-TOKEN': csrfToken(),
          },
          body: JSON.stringify({ name: name, email: email, subject: SUPPORT_SUBJECT, message: message }),
        })
          .then(function (r) { return r.json().catch(function () { return {}; }); })
          .then(function (b) {
            if (b && b.ok) {
              form.reset();
              showAlert('Murojaatingiz yuborildi. Administrator tez orada javob beradi.', 'ok');

              return;
            }

            showAlert('Yuborilmadi. Birozdan keyin qayta urinib ko\'ring.', 'error');
          })
          .catch(function () {
            showAlert('Tarmoq xatosi. Internet aloqasini tekshirib, qayta yuboring.', 'error');
          })
          .then(function () {
            if (submitBtn) { submitBtn.disabled = false; submitBtn.innerHTML = submitHTML; }
          });
      });
    }
  }

  ready(function () {
    // Faqat ommaviy sahifalar: admin qobig'i bo'lsa qo'shilmaydi.
    if (document.querySelector('.admin-shell')) return;
    if (document.getElementById('supportFab')) return; // ikki marta qo'shilmasin

    document.body.insertAdjacentHTML('beforeend', widgetHTML());
    wire();
  });
})(window);
